import React from 'react';
import { IconType, formatDateToLocal } from '~/utils';
import { BulletIcon } from '@applyboard/ui-icons';
import { Flex, Heading, Tag, TagProps, Text } from '@applyboard/crystal-ui';
import { ExpandableCard } from '~/components/uie-fix/ExpandableCard';
import { useApplicationCard, CardSection, useAppProcessing } from '../../context';

type CardProps = {
  id: CardSection;
  icon: IconType;
  title: string;
  children: React.ReactNode;
  hideChevron?: boolean;
  tag?: {
    text: string;
    intent: TagProps['intent'];
  };
  updatedAt?: string;
  updatedByRole?: string;
};

export function Card(props: CardProps) {
  const { application } = useAppProcessing();
  const { isExpanded, toggle } = useApplicationCard(props.id);
  const isChanged = application.meta.changeSet?.includes(props.id);

  const formattedUpdatedAt = props.updatedAt ? formatDateToLocal(new Date(props.updatedAt)) : undefined;

  return (
    <ExpandableCard
      id={props.id}
      icon={props.icon}
      hideChevron={props.hideChevron}
      title={
        <Flex align="center" justify="between" gap={2}>
          <Flex align="center" gap={2}>
            <Heading level={3}>{props.title}</Heading>
            {isChanged && <BulletIcon intent="warning" variant="fill" />}
          </Flex>
          <Flex align="center" gap={2}>
            {formattedUpdatedAt && (
              <Text variant="bodyS" contrast="mid">
                Updated on {formattedUpdatedAt}
                {props.updatedByRole && <> by {props.updatedByRole}</>}
              </Text>
            )}
            {props.tag && (
              <Tag intent={props.tag.intent} size="md">
                {props.tag.text}
              </Tag>
            )}
          </Flex>
        </Flex>
      }
      isExpanded={isExpanded}
      onIsExpandedChange={(expanded) => toggle(expanded)}
    >
      {props.children}
    </ExpandableCard>
  );
}
